import { render, staticRenderFns } from "./ChangeProfilePicture.vue?vue&type=template&id=3d98d392"
import script from "./ChangeProfilePicture.vue?vue&type=script&lang=ts"
export * from "./ChangeProfilePicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d98d392')) {
      api.createRecord('3d98d392', component.options)
    } else {
      api.reload('3d98d392', component.options)
    }
    module.hot.accept("./ChangeProfilePicture.vue?vue&type=template&id=3d98d392", function () {
      api.rerender('3d98d392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/ChangeProfilePicture.vue"
export default component.exports